// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-2-m__wrapper__3U9kE"};